import { createApiRef } from '@backstage/core-plugin-api';

export interface ImageUploadClient {
  upload: (file: File) => Promise<string>;
}

export const imageUploadApiRef = createApiRef<ImageUploadClient>({
  id: 'plugin.image-upload',
});
